// src/components/PrivateRoute.tsx
import { ReactElement } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }: { children: ReactElement }) {
  const { currentUser } = useAuth();

  if (!currentUser) {
    // Return Navigate component which is a valid JSX element
    return <Navigate to="/login" replace />;
  }

  // Return the child component directly which is already a ReactElement
  return children;
}